export const IMAGES_TYPE = 'image/jpeg, image/png';
